namespace $.$$ {

	export class $shm_projects_goal_output extends $.$shm_projects_goal_output {

		process_arg() {
			return { project_output: 'process' }
		}

		result_arg() {
			return { project_output: 'result' }
		}

		process_current() {
			return this.mode() === 'process'
		}

		result_current() {
			return this.mode() === 'result'
		}

		@ $mol_action
		override process_select( next?: MouseEvent ) {
			if( next === undefined ) return null
			next.preventDefault()
			this.mode( 'process' )
			return next
		}

		@ $mol_action
		override result_select( next?: MouseEvent ) {
			if( next === undefined ) return null
			next.preventDefault()
			this.mode( 'result' )
			return next
		}

		output_content() {
			return [ this.mode() === 'result' ? this.result() : this.process().Process_view() ].filter( Boolean ) as $mol_view[]
		}

	}

}
